import React from "react";
import TitleBlock from "../../components/TitleBlock";
import SettingsTopRow from "../Settings/SettingsTopRow";

const CreateNewHeader = () => {
  return (
    <div>
      <SettingsTopRow backRoute="settings" />
      <TitleBlock
        title="Billing"
        subtitle="Manage payment methods and view invoice history"
      />
    </div>
  );
};

export default CreateNewHeader;
